import React from 'react'
import { Footer } from './styles'

const InsideFooter = () => {
  return (
    <Footer>
      <a
        href="https://www.ecommercebrasil.com.br/"
        target="_blank"
        rel="noreferrer"
      >
        ©ecbrDNA by E-Commerce Brasil
      </a>
    </Footer>
  )
}

export default InsideFooter
